import React, { useCallback } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { AUTH_MODAL_EVENT, MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'
import { resolveGeneratorCtaHref } from 'Pods/Shared/AiLanding/generatorCta'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

// "Start generating for free". Signed-out visitors get a real button that opens the in-page
// sign-up modal (hosted by SignInModalHost); once /load-services.js delivers a tier we know
// where to send them, so it becomes a link. Both branches render the same Triangle UI Button,
// so the swap cannot change the box and shift layout on this fast page.
//
// The wrapper carries the 24px offset (CGDream's `.feature-hero__btns`) rather than the Button
// itself, so nothing has to out-specify the runtime-injected `.cgt-button` margins.
function StartCta({ label, subscriptionPaymentFormUrl = '' }) {
  const pageConfig = usePageConfig({ listener: 'full-page-config-loaded', checkIfAvailable: false })
  const tier = pageConfig?.threeDStudioAccessTier
  const paymentFormUrl = pageConfig?.threeDStudioSubscriptionPaymentFormUrl || subscriptionPaymentFormUrl

  const handleClick = useCallback(() => {
    if (typeof App === 'undefined' || !App.events) return

    App.events.publish(AUTH_MODAL_EVENT, { mode: MODE.SIGNUP })
  }, [])

  return (
    <div className="ai-generator-landing__hero-cta">
      {tier ? (
        <Button type="primary" href={resolveGeneratorCtaHref({ tier, paymentFormUrl })}>
          {label}
        </Button>
      ) : (
        <Button type="primary" actionType="button" onClick={handleClick}>
          {label}
        </Button>
      )}
    </div>
  )
}

StartCta.propTypes = {
  label: string.isRequired,
  subscriptionPaymentFormUrl: string,
}

export default StartCta
